import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../../components/Footer';
export function AccessibilityPolicyPage() {
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-4203">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-4204">
        <Link to="/" className="flex items-center gap-2" data-id="element-4205">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-4206"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-4207">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-4xl mx-auto px-6 py-12" data-id="element-4208">
        <h1 className="text-4xl font-bold mb-4" data-id="element-4209">Accessibility Statement</h1>
        <p className="text-sm text-gray-500 mb-8 font-mono" data-id="element-4210">
          Last Updated: {new Date().toLocaleDateString()}
        </p>

        <div className="bg-white border border-gray-300 p-8 space-y-8" data-id="element-4211">
          <section data-id="element-4212">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4213">Our Commitment</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4214">
              Citiplots.com is committed to ensuring digital accessibility for
              people with disabilities. We are continually improving the user
              experience for everyone and applying relevant accessibility
              standards.
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-4215">
              We aim to conform to Level AA of the World Wide Web Consortium
              (W3C) Web Content Accessibility Guidelines (WCAG) 2.1 and comply
              with the Rights of Persons with Disabilities Act, 2016 of India.
            </p>
          </section>

          <section data-id="element-4216">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4217">Accessibility Features</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4218">
              Our platform includes the following accessibility features:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4219">
              <li data-id="element-4220">
                <strong data-id="element-4221">Keyboard Navigation:</strong> Full site navigation using
                keyboard only
              </li>
              <li data-id="element-4222">
                <strong data-id="element-4223">Screen Reader Compatibility:</strong> Semantic HTML and
                ARIA labels for assistive technologies
              </li>
              <li data-id="element-4224">
                <strong data-id="element-4225">Text Alternatives:</strong> Alt text for all meaningful
                images
              </li>
              <li data-id="element-4226">
                <strong data-id="element-4227">Color Contrast:</strong> Minimum 4.5:1 contrast ratio
                for normal text
              </li>
              <li data-id="element-4228">
                <strong data-id="element-4229">Resizable Text:</strong> Text can be resized up to 200%
                without loss of functionality
              </li>
              <li data-id="element-4230">
                <strong data-id="element-4231">Focus Indicators:</strong> Clear visual focus indicators
                for interactive elements
              </li>
              <li data-id="element-4232">
                <strong data-id="element-4233">Form Labels:</strong> All form inputs have associated
                labels
              </li>
              <li data-id="element-4234">
                <strong data-id="element-4235">Error Identification:</strong> Clear error messages and
                correction suggestions
              </li>
              <li data-id="element-4236">
                <strong data-id="element-4237">Consistent Navigation:</strong> Predictable navigation
                structure across pages
              </li>
            </ul>
          </section>

          <section data-id="element-4238">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4239">
              Assistive Technologies Supported
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4240">
              Our platform is designed to work with:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4241">
              <li data-id="element-4242">JAWS (Job Access With Speech)</li>
              <li data-id="element-4243">NVDA (NonVisual Desktop Access)</li>
              <li data-id="element-4244">VoiceOver (macOS and iOS)</li>
              <li data-id="element-4245">TalkBack (Android)</li>
              <li data-id="element-4246">ZoomText and other screen magnifiers</li>
              <li data-id="element-4247">
                Dragon NaturallySpeaking and other voice recognition software
              </li>
            </ul>
          </section>

          <section data-id="element-4248">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4249">Known Limitations</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4250">
              Despite our efforts, some limitations may exist:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4251">
              <li data-id="element-4252">
                Third-party content (maps, embedded videos) may have
                accessibility barriers
              </li>
              <li data-id="element-4253">
                PDF documents uploaded by users may not be fully accessible
              </li>
              <li data-id="element-4254">
                Some complex data visualizations may require alternative text
                descriptions
              </li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4" data-id="element-4255">
              We are actively working to address these limitations in future
              updates.
            </p>
          </section>

          <section data-id="element-4256">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4257">Feedback and Assistance</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4258">
              We welcome your feedback on the accessibility of Citiplots.com. If
              you encounter any accessibility barriers:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4259">
              <li data-id="element-4260">Email: accessibility@citiplots.com</li>
              <li data-id="element-4261">Phone: +91-XXX-XXX-XXXX (Mon-Fri, 9 AM - 6 PM IST)</li>
              <li data-id="element-4262">Contact form: Available on our support page</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4" data-id="element-4263">
              We aim to respond to accessibility feedback within 3 business
              days.
            </p>
          </section>

          <section data-id="element-4264">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4265">Alternative Formats</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-4266">
              If you require information from our platform in an alternative
              format (large print, audio, accessible PDF), please contact us at
              accessibility@citiplots.com. We will provide the information in
              your preferred format within 5 business days.
            </p>
          </section>

          <section data-id="element-4267">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4268">Ongoing Efforts</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4269">
              We are committed to continuous improvement:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4270">
              <li data-id="element-4271">Regular accessibility audits by third-party experts</li>
              <li data-id="element-4272">User testing with people with disabilities</li>
              <li data-id="element-4273">Staff training on accessibility best practices</li>
              <li data-id="element-4274">Incorporating accessibility in our development process</li>
              <li data-id="element-4275">Monitoring and addressing reported issues promptly</li>
            </ul>
          </section>

          <section data-id="element-4276">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4277">
              Technical Specifications
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4278">
              Accessibility of Citiplots.com relies on the following
              technologies:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4279">
              <li data-id="element-4280">HTML5</li>
              <li data-id="element-4281">WAI-ARIA (Accessible Rich Internet Applications)</li>
              <li data-id="element-4282">CSS3</li>
              <li data-id="element-4283">JavaScript (with graceful degradation)</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4" data-id="element-4284">
              These technologies are relied upon for conformance with WCAG 2.1
              Level AA.
            </p>
          </section>

          <section data-id="element-4285">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4286">Formal Complaints</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-4287">
              If you are not satisfied with our response to your accessibility
              concern, you may file a formal complaint with:
            </p>
            <div className="mt-4 p-4 bg-gray-50 border border-gray-200" data-id="element-4288">
              <p className="font-mono text-sm" data-id="element-4289">
                <strong data-id="element-4290">
                  Chief Commissioner for Persons with Disabilities
                </strong>
                <br data-id="element-4291" />
                Government of India
                <br data-id="element-4292" />
                Website: www.ccdisabilities.nic.in
                <br data-id="element-4293" />
                Email: ccpd@nic.in
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer data-id="element-4294" />
    </div>;
}